/**
 * 全局配置
 */

 module.exports = {
  //端口
  port: '8883',

  //接口协议类型
  apiProtocol: 'https',

  //移动端最大支持的页面宽度
  mobileMaxWidth: 500,

  //本地调试，接口域名
  devApi: 'localhost',

  //网站根目录
  baseUrl: '',

  //接口根目录
  apiBaseUrl: '',

  //静态文件根目录
  staticUrl: '/' + process.env.VUE_APP_STATIC + '/',

  //路由二级路径
  routeBasePath: process.env.VUE_APP_PATH,

  //下载文件根目录
  uploadUrl: '',

  //图片域名
  upImageUrl: 'https://hlmtj-img.artroncloud.com/',

  //路径转换列表
  pcMobileChange: [],
}
